import { Controller } from "stimulus";
import "./opportunity.css";

export default class extends Controller {
  initialize() {}

  connect() {}
}
